export type ColorScale = {
  readonly [key: string]: string;
};

export const SubjectColorKeys = {
  // Change according to backend responses
  Chem: "chem",
  Chemistry: "chemistry",
  Phy: "phy",
  Physics: "physics",
  Bio: "bio",
  Biology: "biology",
  Botany: "botany",
  Math: "math",
  Maths: "maths",
  Mat: "mat",
  Mathematics: "mathematics",
  MathAppliedMath: "math/applied math",
  AppliedMathematics: "applied mathematics",
  Arithmetic: "arithmetic",
  Eng: "eng",
  English: "english",
  EnglishV1: "english v1",
  EnglishEnhancementProgram: "english enhancement program",
  Zoology: "zoology",
  Sci: "sci",
  Science: "science",
  Evs: "evs",
  EnvironmentalStudy: "environmental studies",
  Cs: "cs",
  Hindi: "hindi",
  Telugu: "telugu",
  ComputerScience: "computer science",
  Social: "social",
  SocialStudies: "social studies",
  Civics: "civics",
  Geo: "geo",
  Geography: "geography",
  History: "history",
  Reasoning: "reasoning",
  MentalAbility: "mental ability",
  Logical: "logical",
  LogicalReasoning: "logical reasoning",
  Gk: "gk",
  GeneralTest: "general test",
  Stats: "stats",
  Commerce: "commerce",
  Business: "business",
  Eco: "eco",
  Economics: "economics",
  Hots: "hots",
  Intso: "intso",
  Nasa: "nasa",
  Kat: "kat",
  CriticalThinking: "critical thinking",
  ProblemSolving: "problem solving",
  VedicMath: "vedic math",
  VedicMathmatics: "vedic mathematics",
  EnvironmentalStudies: "Environmental Studies",
} as const;

export type SubjectColorKey =
  (typeof SubjectColorKeys)[keyof typeof SubjectColorKeys];

export type SubjectColors = Readonly<
  Partial<Record<SubjectColorKey, ColorScale>>
>;

export interface ThemeColors {
  primary: ColorScale;
  secondary: ColorScale;
  tertiary: ColorScale;
  neutral: ColorScale;
  success: ColorScale;
  error: ColorScale;
  warning: ColorScale;
  text: ColorScale;
  background: ColorScale;
  subject: SubjectColors;
  overlay: string;
  test: ColorScale;
  buttonSuccess: string;
  ainaChat: ColorScale;
  doubtsResolved: ColorScale;
  doubtImageEditGradient: readonly [string, string];
}
